module.exports = __webpack_public_path__ + "static/media/bg_premium.4c2c4e4c.png";